import apiHeader from '@/helpers/apiHeader';

const massUpdateMrpFormService = {
    save(id, params) {
        return apiHeader.post(`request-pool/mass-update/save/${id}`, params);
    },
    importItems(id, file) {
        const fd = new FormData();
        fd.append('file', file);
        return apiHeader.post(`request-pool/mass-update/import/${id}`, fd, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
    },
    downloadTemplate() {
        return apiHeader.get('request-pool/mass-update/template', { responseType: 'blob' });
    },
    getAttachments(mcrCode) {
        return apiHeader.get(`request-pool/emcr-attachment/${mcrCode}`);
    },
    uploadAttachment(mcrCode, file, onUploadProgress) {
        const fd = new FormData();
        fd.append('file', file);
        return apiHeader.post(`request-pool/emcr-attachment/${mcrCode}`, fd, {
            headers: { 'Content-Type': 'multipart/form-data' },
            ...(onUploadProgress ? { onUploadProgress } : {}),
        });
    },
    deleteAttachment(id) {
        return apiHeader.delete(`request-pool/emcr-attachment/${id}`);
    },
};

export default massUpdateMrpFormService;
